













































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';

@Component({})
export default class UpdatePaymentModal extends Mixins(ModalMixin) {
  form!: CrsForm<'payments', 'updateBalancePayment'>;

  @Watch('open')
  onInit(isOpen: boolean) {
    if (isOpen) {
      compass
        .do('payments', 'findOneBalancePayment', {
          // TODO: ...
          params: { balancePaymentId: this.id },
        })
        .then((res) => {
          this.form = this.$crsForm('payments', 'updateBalancePayment', res.data);
        });
    } else {
      this.form = this.$crsForm('payments', 'updateBalancePayment', {
        paymentDate: new Date(),
        amount: 0,
        currency: 'TRY',
        order: '',
        note: '',
      });
    }
  }
}
